export const onInitialClientRender = () => {
  window.scrollTo(0, 0);
};
